import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CustomTextField from "../../Components/TextField";
import { Box, Checkbox, FormControlLabel, FormGroup, FormHelperText, IconButton } from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useErrorHandler } from "../../hooks";
import HelmetReact from "../../Components/Helmet";
import "./style.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import useToggle from "../../hooks/use-toggle";
import {
  AddExisitingUser,
  RegisterAction,
} from "../../Redux/Actions/AuthActions";
import { getPractitionersEmailAction } from "../../Redux/Actions/userAction";
import { useState } from "react";
import { useEffect } from "react";
import { useDebounce } from "../../hooks/use-debounced";

const AddUser = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const [visiblePassword, setVisiblePassword] = useToggle(true);
  const [visibleConfirmPassword, setVisibleConfirmPassword] = useToggle(true);
  const { setMsgConfig } = useErrorHandler();
  const [email, setEmail] = useState("");
  const [isEmailExist, setIsEmailExist] = useState(false);
  const { loading } = useSelector((state) => state.Auth);
  const inputEmail = useDebounce(email, 1000);
  const { doctorList } = useSelector((state) => state.User);
  const [practitionerList, setPractitionerList] = useState([]);
  const [reseacherChecked, setReseacherChecked] = useState(false);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      email: yup
        .string()
        .required("Please Enter email")
        .email()
        .matches(
          /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/,
          "please enter valid email"
        ),
      first_name: !isEmailExist
        ? yup
            .string()
            .min(3, "Minimum 3 Characters Required")
            .max(10, "Maximum 10 Characters Allowed")
            .required("First Name Required")
        : yup.string().optional(),
      last_name: !isEmailExist
        ? yup
            .string()
            .min(3, "Minimum 3 Characters Required")
            .max(10, "Maximum 10 Characters Allowed")
            .required("Last Name Required")
        : yup.string().optional(),
      password: !isEmailExist
        ? yup
            .string()
            .required("Please Enter Password")
            .min(3, "characters must be more than 3")
            .matches(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
              "Password must have 8 characters,1 special character,1 UpperCase letter,1 LowerCase letter"
            )
        : yup.string().optional(),
      confirmPassword: !isEmailExist
        ? yup
            .string()
            .required()
            .oneOf([yup.ref("password"), null], "Password Must Match")
        : yup.string().optional(),
    }),
    onSubmit: (values) => {
      if (!isEmailExist && reseacherChecked === false) {
        let payload = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          password: values.confirmPassword,
          role: "editor",
        };
        if (!loading) {
          dispatch(RegisterAction(payload));
          setMsgConfig({
            alertOpen: true,
            message: "Registered successfully!",
            severity: "success",
            autoHideDuration: 2000,
          });
          setOpen(!open);
        }
      } else if (!isEmailExist && reseacherChecked === true) {
        let payload = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          password: values.confirmPassword,
          role: "researcher",
        };
        if (!loading) {
          dispatch(RegisterAction(payload));
          setMsgConfig({
            alertOpen: true,
            message: "Registered successfully!",
            severity: "success",
            autoHideDuration: 2000,
          });
          setOpen(!open);
        }
      } else {
        let payload = {
          email: formik.values.email,
        };
        if (!loading) {
          dispatch(AddExisitingUser(payload));
          setMsgConfig({
            alertOpen: true,
            message: "Registered successfully!",
            severity: "success",
            autoHideDuration: 2000,
          });
          setOpen(!open);
        }
      }
    },
  });

  const payload = {
    key: "",
  };
  useEffect(() => {
    dispatch(getPractitionersEmailAction(payload));
  }, [dispatch]);

  useEffect(() => {
    doctorList?.length &&
      doctorList?.map((item) => {
        practitionerList.push(item.email);
      });
  }, []);

  const handleResearcher = (event) => {
    setReseacherChecked(event.target.checked);
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
    formik.setFieldValue("email", e.target.value);
  };

  useEffect(() => {
    setIsEmailExist(false);
    practitionerList?.map((item) => {
      if (inputEmail?.length && !formik.errors.email) {
        if (item?.includes(inputEmail)) {
          setIsEmailExist(true);
          formik.setFieldValue("email", inputEmail);
        }
        formik.setFieldValue("email", inputEmail);
      }
    });
  }, [inputEmail]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(!open);
  };
  return (
    <>
      <HelmetReact name="Setting" />
      <Dialog open={open} onClose={handleClose} className="invite-modal">
        <DialogTitle>
          {!isEmailExist ? "ADD NEW USER" : "ADD EXSITING USER"}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ my: 3 }}>
            <CustomTextField
              fieldType="simpleTextInput"
              name="email"
              fullWidth
              required
              value={email}
              onChange={handleChange}
              onBlur={formik.handleBlur}
              placeholder={"Enter email *"}
              error={formik.touched.email && formik.errors.email ? true : false}
            />
            {formik.touched.email && formik.errors.email && (
              <FormHelperText className="error_message">
                {formik.errors.email}
              </FormHelperText>
            )}
          </Box>
          {!isEmailExist ? (
            <>
              {" "}
              <Box>
                <CustomTextField
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                  fullWidth
                  disabled={isEmailExist ? true : false}
                  id="first_name"
                  name="first_name"
                  error={
                    formik.touched.first_name && formik.errors.first_name
                      ? true
                      : false
                  }
                  placeholder="Enter first name *"
                  fieldType="simpleTextInput"
                />

                {formik.touched.first_name && formik.errors.first_name && (
                  <FormHelperText className="error_text_message">
                    {formik.errors.first_name}
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ my: 3 }}>
                <CustomTextField
                  fieldType="simpleTextInput"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                  fullWidth
                  disabled={isEmailExist ? true : false}
                  id="last_name"
                  name="last_name"
                  autoComplete="last_name"
                  placeholder={"Enter last name *"}
                  error={
                    formik.touched.last_name && formik.errors.last_name
                      ? true
                      : false
                  }
                />
                {formik.touched.last_name && formik.errors.last_name && (
                  <FormHelperText className="error_text_message">
                    {formik.errors.last_name}
                  </FormHelperText>
                )}
              </Box>
              <Box className="input form-control-label">
                <CustomTextField
                  fieldType="simpleTextInput"
                  type={visiblePassword ? "password" : "text"}
                  fullWidth
                  disabled={isEmailExist ? true : false}
                  variant="Outlined"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder={"Enter your Password"}
                  error={
                    formik.touched.password && formik.errors.password
                      ? true
                      : false
                  }
                />
                <IconButton
                  disabled={isEmailExist ? true : false}
                  className="reset-toggle-eye"
                  onClick={setVisiblePassword}
                >
                  {visiblePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
                {formik.touched.password && formik.errors.password && (
                  <FormHelperText className="error_message">
                    {formik.errors.password}
                  </FormHelperText>
                )}
              </Box>
              <Box className="input form-control-label" sx={{ my: 3 }}>
                <CustomTextField
                  fieldType="simpleTextInput"
                  type={visibleConfirmPassword ? "password" : "text"}
                  fullWidth
                  disabled={isEmailExist ? true : false}
                  variant="Outlined"
                  name="confirmPassword"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder={"Re-Enter Password"}
                  error={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                      ? true
                      : false
                  }
                />
                <IconButton
                  disabled={isEmailExist ? true : false}
                  className="reset-toggle-eye"
                  onClick={setVisibleConfirmPassword}
                >
                  {visibleConfirmPassword ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </IconButton>
                {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword && (
                    <FormHelperText className="error_message">
                      {formik.errors.confirmPassword}
                    </FormHelperText>
                  )}
              </Box>
              <Box sx={{ my: 3 }}>
                <FormGroup>
                  <FormControlLabel control={<Checkbox onChange={handleResearcher} />} label="Researcher" />
                </FormGroup>
              </Box>
              {" "}
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button className="btn-dark" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="btn-dark"
            variant="contained"
            onClick={formik.handleSubmit}
          >
            {!isEmailExist ? "ADD NEW USER" : "ADD EXSITING USER"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddUser;
